<template>
  <div>
    <div class="relative flex items-center featured-container">
      <div class="container pax20 flex justify-center items-center-l tc">
        <div class="featured-image-container absolute absolute--fill z-0">
          <img
            :data-srcset="require('~/assets/images/about-cover.jpg').srcSet"
            data-src="~assets/images/about-cover.jpg"
            class="image-cover lazyload"
          />
        </div>
        <div class="absolute absolute--fill z-1 bg-linear-gradient"></div>
        <div class="white z-2 pa2 pl0-l pr4-l mb5-l">
          <h1 class="ma0 mb4 mt4-l lh-title f1 mw7">
            {{ $t('press.heading') }}
          </h1>
          <p class="dn db-l pb3 mb4 mw7 fs-subheading">
            {{ $t('press.subheading') }}
            <a href="mailto:press@discontract.com" class="white"
              >press@discontract.com</a
            >
          </p>
          <a
            href="https://elementup-my.sharepoint.com/:f:/g/personal/laurynas_discontract_com/En1GN_UYxNFNsFliO5iYXCwBmy-Tbcl1Ed9Cwlthn-C-0w"
            class="no-underline pointer mb2 mb0-l dib white fw7 br-pill bg-green button-large"
            >{{ $t('press.pressKit') }}</a
          >
        </div>
      </div>
    </div>
    <div class="container pax20">
      <div class="pv4">
        <nuxt-link :to="localePath({ name: 'index' })" class="mr1"
          ><img
            src="~/assets/icons/ic_home.svg"
            width="16"
            height="16"
            class="v-mid"
        /></nuxt-link>
        <img
          src="~/assets/icons/ic_arrow_bc.svg"
          width="6"
          height="10"
          class="mr1"
        />
        {{ $t('navigation.about') }}
      </div>
      <div class="tc flex flex-column items-center flex-row-l pa4 mb5">
        <div class="w-25-l">
          <p class="f2">{{ $t('press.stats.launched') }}</p>
          <p class="f4">{{ $t('press.stats.launchedLabel') }}</p>
        </div>
        <div class="w-25-l">
          <p class="f2">{{ $t('press.stats.users') }}</p>
          <p class="f4">{{ $t('press.stats.usersLabel') }}</p>
        </div>
        <div class="w-25-l">
          <p class="f2">{{ $t('press.stats.pros') }}</p>
          <p class="f4">{{ $t('press.stats.prosLabel') }}</p>
        </div>
        <div class="w-25-l">
          <p class="f2">{{ $t('press.stats.cities') }}</p>
          <p class="f4">{{ $t('press.stats.citiesLabel') }}</p>
        </div>
      </div>
      <img
        :data-srcset="require('~/assets/images/press.jpg').srcSet"
        data-src="~assets/images/press.jpg"
        class="lazyload"
      />
      <div class="container pax20 relative z-4">
        <div class="pa4 ph7-l pv5-l tc">
          <h2 class="">{{ $t('press.intro.heading') }}</h2>
          <p class="">{{ $t('press.intro.text') }}</p>
        </div>
      </div>
    </div>
    <div class="map-container z-1 overflow-hidden nt7">
      <img
        class="w-100 lazyload image-cover"
        data-src="~assets/images/about-map.svg"
        width="1280"
        height="800"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Press',
  scrollToTop: true,
  head() {
    return {
      title: this.$t('press.title'),
      meta: [
        // hid is used as unique identifier. Do not use `vmid` for it as it will not work
        {
          hid: 'description',
          name: 'description',
          content: this.$t('press.description'),
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.$t('press.description'),
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.$t('press.title'),
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://discontract.com${this.$route.path.replace(
            /\/?$/,
            '/'
          )}`,
        },
      ],
    };
  },
};
</script>
